import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  CapContactsPopupComponentDefaultProps,
  CapContactsPopupComponentPropTypes,
} from 'src/components/CapContactsPopup/propTypes';
import { Popup } from 'src/components/Popup';
import { ServiceType } from 'src/components/CapBox/constants';
import { useSetJobContact } from 'src/hooks/companyContact/useSetJobContact';
import FormRow from 'src/components/Form/FormRow';
import s from 'src/components/JobForm/JobForm.styles';
import SelectBox from 'src/components/SelectBox';
import Loader from 'src/components/Loader';

const CapContactsPopupComponent = (
  {
    companyContacts,
    isSubmitting,
    jobId,
    onClose,
    onSubmit,
    setIsSubmitting,
  }) => {
  const { t } = useTranslation();

  const [selectedContacts, setSelectedContacts] = useState([]);

  const { isLoading, setJobContactCallback: setJobContact } = useSetJobContact(ServiceType);

  return (
    <Popup
      onClose={onClose}
      title={<s.Title>{t('SELECT_A_CONTACT')}</s.Title>}
      withOverflow
      >
      {
        <FormRow inline spaced>
          <SelectBox
            disabled={isLoading || isSubmitting}
            isMulti
            onChange={v => setSelectedContacts(v || [])}
            options={
              companyContacts
                .sort((a, b) => (a.label.trim() > b.label.trim()) ? 1 : -1)
                .map(contact => ({
                  label: contact.label,
                  value: contact.contactIds,
                }))
            }
            value={selectedContacts || null}
          />
          <s.SubmitButton
            disabled={selectedContacts.length === 0 || isLoading || isSubmitting}
            gray={selectedContacts.length === 0 || isLoading || isSubmitting}
            onClick={async e => {
              e.preventDefault();
              setIsSubmitting(true);
              const response = await setJobContact({
                contactIds: selectedContacts.map(contact => contact.value).flat(),
                jobId,
              });

              if (response) {
                onSubmit();
              } else {
                setIsSubmitting(false);
              }
            }}
            orange
            sm
            solid
          >
            {t('OK')}
          </s.SubmitButton>
          {isSubmitting ?
            <Loader text="PLEASE_WAIT" withText={true} />
            : <s.LinkButton
              disabled={isLoading || isSubmitting}
              ghost
              onClick={onClose}
              red
              sm
              type="button"
            >
              {t('CANCEL')}
            </s.LinkButton>
          }
        </FormRow>
      }
    </Popup>
  );
};

CapContactsPopupComponent.propTypes = CapContactsPopupComponentPropTypes;
CapContactsPopupComponent.defaultProps = CapContactsPopupComponentDefaultProps;

export const CapContactsPopup = memo(CapContactsPopupComponent);
